

import { Box, Tooltip, TooltipProps } from '@mui/material';
import { ISelectProps, Select } from '@ngt/opms';
import { FC } from 'react'

interface ISelectWithTooltipProps extends ISelectProps {
    tooltipProps: Omit<TooltipProps, 'children'>;
}

const SelectWithTooltip: FC<ISelectWithTooltipProps> = ({
    tooltipProps,
    ...rest
}) => {
    return (
        <Tooltip
            {...tooltipProps}
        >
            <Box width="100%">
                <Select 
                    {...rest}
                    fullWidth
                />
            </Box>
        </Tooltip>
    );
}

export default SelectWithTooltip